module.exports = __webpack_public_path__ + "img/icon5.7d3b33f.png";